// Proje bazlı SSE (presence/events kanalındaki "project" olayları) — tek bağlantı.
// onEvent ref'te tutulur: callback kimliği değişince yeniden bağlanılmaz.
import { useEffect, useRef } from "react";

export interface ProjectEvent {
  type: string;
  checkId?: string;
  status?: string;
  findingCount?: number;
}

export function useProjectEvents(
  projectId: string | undefined,
  onEvent: (evt: ProjectEvent) => void,
): void {
  const ref = useRef(onEvent);
  useEffect(() => {
    ref.current = onEvent;
  }, [onEvent]);

  useEffect(() => {
    if (!projectId) return;
    const es = new EventSource(`/api/v1/projects/${projectId}/presence/events`, {
      withCredentials: true,
    });
    const handler = (e: MessageEvent<string>): void => {
      try {
        ref.current(JSON.parse(e.data) as ProjectEvent);
      } catch {
        // bozuk payload — yoksay
      }
    };
    es.addEventListener("project", handler as EventListener);
    return () => {
      es.removeEventListener("project", handler as EventListener);
      es.close();
    };
  }, [projectId]);
}
